const recsCache = {};

class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.cartIds = (this.dataset.cartProductIds || '').split(',').filter(Boolean);
    this.list = this.querySelector('.cart-recs__list');
    this.load();
  }

  async load() {
    try {
      if (!recsCache[this.productId]) {
        const root = window.Shopify?.routes?.root || '/';
        const url = `${root}recommendations/products.json?product_id=${this.productId}&limit=10&intent=related`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('recommendations failed');
        recsCache[this.productId] = (await res.json()).products || [];
      }

      const limit = parseInt(this.dataset.limit, 10) || 8;
      const products = recsCache[this.productId]
        .filter((p) => !this.cartIds.includes(String(p.id)) && p.available)
        .slice(0, limit);

      if (!products.length) return;

      this.list.innerHTML = products.map((p) => this.card(p)).join('');
      this.hidden = false;

      this.list.querySelectorAll('[data-add-variant]').forEach((btn) => {
        btn.addEventListener('click', () => this.add(btn));
      });
    } catch (e) {
      console.error(e);
    }
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  }

  card(p) {
    const img = p.featured_image
      ? `<img src="${p.featured_image}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy" width="200" height="200">`
      : '';
    const multi = p.variants && p.variants.length > 1;
    const variant = (p.variants || []).find((v) => v.available) || p.variants[0];

    // Products with several variants link to the product page; single-variant ones get a quick-add button
    const action = multi
      ? `<a class="cart-recs__add" href="${p.url}" aria-label="View ${p.title}">+</a>`
      : `<button type="button" class="cart-recs__add" data-add-variant="${variant.id}" aria-label="Add ${p.title} to cart">+</button>`;

    return `
      <div class="cart-recs__card">
        <a href="${p.url}" class="cart-recs__media">${img}</a>
        <div class="cart-recs__info">
          <a href="${p.url}" class="cart-recs__name">${p.title}</a>
          <div class="cart-recs__row">
            <span class="cart-recs__price">${this.formatMoney(p.price)}</span>
            ${action}
          </div>
        </div>
      </div>`;
  }

  async add(btn) {
    const drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: btn.dataset.addVariant,
          quantity: 1,
          sections: drawer.getSectionsToRender().map((s) => s.id),
          sections_url: window.location.pathname,
        }),
      });
      const state = await res.json();
      if (state.status) throw new Error(state.description || 'Add failed');
      drawer.renderContents(state);
    } catch (e) {
      console.error(e);
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}